<router-link class="logo" to="/"><InlineSvg :src="require(`@/assets/images/logo.svg`)"></InlineSvg></router-link>